module.exports = __webpack_public_path__ + "static/media/Without-sound.cb67f439.svg";